

import { PlayIcon, PauseIcon } from '../icons/NavigationIcons';
import ControlButton from '../ControlButton';

interface PlayPauseButtonProps {
  isRunning: boolean;
  onToggle: () => void;
  isMobile: boolean;
}

const PlayPauseButton = ({
  isRunning,
  onToggle,
  isMobile
}) => {
  const handleClick = (e: React.MouseEvent) => {
    // Prevent event bubbling
    e.stopPropagation();
    console.log(`PlayPauseButton: clicked - current state: ${isRunning ? 'running' : 'paused'}`);
    onToggle();
  };

  return (
    <ControlButton 
      onClick={handleClick}
      size="large"
      ariaLabel={isRunning ? "Pause" : "Play"}
      className=""
    >
      {isRunning ? <PauseIcon size={isMobile ? 24 : 28} /> : <PlayIcon size={isMobile ? 24 : 28} />}
    </ControlButton>
  );
};

export default PlayPauseButton;
